module.exports = __webpack_public_path__ + "img/success2.c3e6f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success_img/success2.jpg
// module id = mmtk
// module chunks = 0